import api from './api';

const BlockedDateService = {
  /**
   * Get all blocked dates
   * @param {Object} params - Query parameters (startDate, endDate, status, appliesTo)
   * @returns {Promise} API response
   */
  getBlockedDates: async (params = {}) => {
    try {
      const response = await api.get('/admin/blocked-dates', params);
      return response;
    } catch (error) {
      console.error('Error fetching blocked dates:', error);
      throw error;
    }
  },

  /**
   * Get a single blocked date by ID
   * @param {string} id - Blocked date ID
   * @returns {Promise} API response
   */
  getBlockedDateById: async (id) => {
    try {
      const response = await api.get(`/admin/blocked-dates/${id}`);
      return response;
    } catch (error) {
      console.error('Error fetching blocked date:', error);
      throw error;
    }
  },

  /**
   * Create a new blocked date
   * @param {Object} data - Blocked date data
   * @returns {Promise} API response
   */
  createBlockedDate: async (data) => {
    try {
      const response = await api.post('/admin/blocked-dates', data);
      return response;
    } catch (error) {
      console.error('Error creating blocked date:', error);
      throw error;
    }
  },

  /**
   * Update an existing blocked date
   * @param {string} id - Blocked date ID
   * @param {Object} data - Updated data
   * @returns {Promise} API response
   */
  updateBlockedDate: async (id, data) => {
    try {
      const response = await api.put(`/admin/blocked-dates/${id}`, data);
      return response;
    } catch (error) {
      console.error('Error updating blocked date:', error);
      throw error;
    }
  },

  /**
   * Delete (cancel) a blocked date
   * @param {string} id - Blocked date ID
   * @param {boolean} permanent - Whether to permanently delete (default: false)
   * @returns {Promise} API response
   */
  deleteBlockedDate: async (id, permanent = false) => {
    try {
      const params = permanent ? { permanent: 'true' } : {};
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `/admin/blocked-dates/${id}?${queryString}` : `/admin/blocked-dates/${id}`;
      const response = await api.delete(url);
      return response;
    } catch (error) {
      console.error('Error deleting blocked date:', error);
      throw error;
    }
  },

  /**
   * Check if a date is available
   * @param {string} date - Date to check (YYYY-MM-DD)
   * @param {string} eventTypeId - Optional event type ID
   * @returns {Promise} API response
   */
  checkDateAvailability: async (date, eventTypeId = null) => {
    try {
      const params = { date };
      if (eventTypeId) {
        params.eventTypeId = eventTypeId;
      }
      const response = await api.get('/admin/blocked-dates/check-availability', params);
      return response;
    } catch (error) {
      console.error('Error checking date availability:', error);
      throw error;
    }
  }
};

export default BlockedDateService;
